import axios from "axios";
import { FeatureCollection } from "../../../types/model/captureLocation";
import { SessionStore } from "../../../types/store";
import { newAbortSignal } from "../../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures`;

export const getCaptureLocationMap = async (
  entityId?: number,
  managementUnitId?: number,
  captureId?: number,
  militaryMap?: string,
  search?: string,
): Promise<FeatureCollection> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<FeatureCollection>(`${BASE_URL}/location/map`, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    params: { entityId, managementUnitId, captureId, militaryMap, search },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
        : AbortSignal.timeout(Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
  });

  return res.data;
};
